import { useMemo } from "react"

import { useFetchCurrentUser } from "@/hooks/api/users/queries"

/**
 * Returns the IANA timezone string for `bookId` by looking it up in the
 * current user's cached `books` list. Returns `undefined` when the book or
 * timezone isn't available — callers should fall back to browser-local
 * rendering in that case.
 */
export function useBookTimezone(bookId?: string | null): string | undefined {
  const { data: user } = useFetchCurrentUser()

  return useMemo(() => {
    if (!bookId || !user?.books) return undefined
    return user.books.find((b) => b.id === bookId)?.timezone ?? undefined
  }, [bookId, user?.books])
}
